<ui-input-wrapper
  [label]="base.label"
  [help]="base.help"
  [randomInputId]="randomInputId"
  [labelTemplate]="base.labelTemplate"
  [help]="base.help"
  [errors]="control.errors"
  [submitted]="submitted"
  [control]="control"
  [errorLabels]="base.errorLabels()">
  <p-datepicker
    #calendarRef
    class="flex w-full"
    [showIcon]="true"
    [inputId]="randomInputId"
    [placeholder]="base.placeholder"
    [appendTo]="dropdown.appendTo()"
    [minDate]="datePicker.minDate()"
    [maxDate]="datePicker.maxDate()"
    [showOnFocus]="false"
    (onSelect)="fireHandleChange($event)"
    (onInput)="fireControlChange()"
    (onShow)="handleShow()"
    (onClose)="handleOnClose()"
    (onMonthChange)="handleOnMonthChange()"
    (onClear)="handleClear()"
    (keydown)="restrictInput($event)"
    (keydown.enter)="handleOnEnter($event)"
    [showTime]="datePicker.showTime()"
    [showClear]="true"
    [timeOnly]="datePicker.timeOnly()"
    [baseZIndex]="10000"
    [firstDayOfWeek]="1"
    [panelStyle]="panelStyle()"
    [panelStyleClass]="dropdown.panelStyleClass()"
    [dateFormat]="datePicker.dateFormat()"
    [keepInvalid]="datePicker.keepInvalid()"
    [formControl]="innerControl">
  </p-datepicker>
</ui-input-wrapper>
